/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import BaseInput from '@ui-kit/inputs/baseInput/BaseInput';

export const StyledSearchInput = styled(BaseInput)`
  border-radius: 50px;
  min-height: 1.8em;
  padding: 0.5em 1.125em;
`;
